import {
  dont_know,
  hhs_programs,
  office_of_the_secretary,
  hhs_business_units
} from 'hotline_complaint_choices'
import { convertHashToChoiceArray } from '../choices/convertHashToChoiceArray'

const dontKnow = Object.keys(dont_know).shift()
const dontKnowLabel = Object.values(dont_know).shift()

export const addDefaultOption = (
  choices,
  defaultLabel = '',
  includeDontKnow = false
) => {
  const newChoices = [{ label: defaultLabel, value: '' }].concat(choices)
  return includeDontKnow
    ? newChoices.concat([{ label: dontKnowLabel, value: dontKnow }])
    : newChoices
}

export const getOptions = (object, defaultLabel, includeDontKnow) =>
  addDefaultOption(
    convertHashToChoiceArray(object),
    defaultLabel,
    includeDontKnow
  )

export const programChoices = getOptions(hhs_programs)
export const offOfSecretaryChoices = getOptions(office_of_the_secretary)
export const businessUnits = Object.keys(hhs_business_units).reduce(
  (acc, key) => ({
    ...acc,
    [key]: getOptions(hhs_business_units[key] || {}, '', true)
  }),
  {}
)

export const additionalDetailField = {
  label: 'Office name',
  type: 'text',
  name: 'hhs_program_detail'
}

export const dontKnowHint =
  'To the best of your ability, please provide as much information as you can about the relevant program or office.'
export const knownHint =
  'To the best of your ability, please provide additional details to fully identify the relevant office. For example: Office of the Inspector General/Office of Investigations/Investigations Branch/Hotline Operations.'

export const knownDetailCondition = {
  value: 'ANY',
  not: dontKnow,
  fields: [
    {
      ...additionalDetailField,
      hint: knownHint
    }
  ]
}

export const dontKnowDetailCondition = {
  value: dontKnow,
  fields: [
    {
      ...additionalDetailField,
      hint: dontKnowHint
    }
  ]
}

export const businessUnitField = {
  type: 'select',
  choices: {
    parentField: 'hhs_program',
    choices: businessUnits
  },
  name: 'business_unit',
  label: 'Business unit',
  conditionals: [knownDetailCondition, dontKnowDetailCondition]
}

export const officeOfSecretaryField = {
  type: 'select',
  choices: offOfSecretaryChoices,
  name: 'office_of_secretary',
  label: 'Staff division',
  conditionals: [
    {
      value: 'ANY',
      not: dontKnow,
      fields: [
        {
          ...businessUnitField,
          choices: {
            parentField: 'office_of_secretary',
            choices: businessUnits
          }
        }
      ]
    },
    dontKnowDetailCondition
  ]
}

export const hhsProgramsField = {
  name: 'hhs_program',
  choices: programChoices,
  label: 'Program',
  type: 'select',
  conditionals: [
    {
      value: 'ANY',
      not: ['OS','FRAUD_GOV', dontKnow],
      fields: [businessUnitField]
    },
    {
      value: 'OS',
      fields: [officeOfSecretaryField]
    },
    dontKnowDetailCondition
  ]
}
